var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgObject = function SvgObject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.595 2.595C3.929 1.26 5.926.75 8.5.75h6c2.574 0 4.57.51 5.905 1.845C21.74 3.929 22.25 5.926 22.25 8.5v6c0 2.574-.51 4.57-1.845 5.905-1.334 1.335-3.331 1.845-5.905 1.845h-6c-2.574 0-4.57-.51-5.905-1.845C1.26 19.071.75 17.074.75 14.5v-6c0-2.574.51-4.57 1.845-5.905Zm1.06 1.06C2.74 4.571 2.25 6.074 2.25 8.5v6c0 2.426.49 3.93 1.405 4.845.916.915 2.419 1.405 4.845 1.405h6c2.426 0 3.93-.49 4.845-1.405.915-.916 1.405-2.419 1.405-4.845v-6c0-2.426-.49-3.93-1.405-4.845-.916-.915-2.419-1.405-4.845-1.405h-6c-2.426 0-3.93.49-4.845 1.405Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32.772a.75.75 0 0 1 .908.548l4.95 20a.75.75 0 0 1-1.456.36l-4.95-20A.75.75 0 0 1 8.32.772Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.75 11.51a.75.75 0 0 1-.51.93l-9.53 2.78a.75.75 0 1 1-.42-1.44L10.82 11a.75.75 0 0 1 .93.51Z",
    fill: "currentColor"
  })));
};
export default SvgObject;